
import { defineComponent, reactive, onMounted } from 'vue'

import NewModal from '@/common/new-components/NewModal/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'

import { getCitiesGrouped } from '@/new-services/location.service'
import type { LocationCitiesGroup } from '@/new-services/types/location'

export default defineComponent({
    components: {
        NewModal,
        TheButton,
        Loader
    },
    emits: ['cancel'],
    setup(_, { emit }) {
        const state = reactive({
            active_tab: 1,
            is_loading: false,
            is_failed: false,
            cities_groups: [] as Array<LocationCitiesGroup>
        })
        

        const loadCitiesGrouped = async () => {
            try {
                state.is_loading = true

                const response = await getCitiesGrouped()
                state.cities_groups = response.data.data

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const onCancel = () => {
            emit('cancel')
        }

        onMounted(loadCitiesGrouped)

        return {
            state,
            onCancel,
            loadCitiesGrouped
        }
    }
})
